// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2D7Xq","rootMargin":"styles_rootMargin__Zjp7O"};